import { AxiosError } from "axios";
import { ExportReportType, REPORT_EXPORTS } from "@sscs/types";

export type NotificationDownloadMessages = {
  progress: string;
  success: string;
  cancel: string;
  error: (error: AxiosError) => string;
};

const notificationsForReportDownload = (
  reportType: ExportReportType,
): NotificationDownloadMessages => ({
  progress: `Exporting ${REPORT_EXPORTS[reportType]} report`,
  success: `Exported ${REPORT_EXPORTS[reportType]} report`,
  cancel: `Canceled ${REPORT_EXPORTS[reportType]} report export`,
  error: (error: AxiosError) =>
    `Could not download report: ${JSON.stringify(error.response?.data)}`,
});

const notificationsForFileDownload = (
  fileName: string,
): NotificationDownloadMessages => ({
  progress: `Downloading ${fileName}`,
  success: `Downloaded ${fileName}`,
  cancel: `Canceled ${fileName} download`,
  error: (error: AxiosError) =>
    `Could not download file: ${JSON.stringify(error.response?.data)}`,
});

export { notificationsForReportDownload, notificationsForFileDownload };
